const DEEP_DIVE_QUESTIONS = [
  'Why did this happen?',
  'What was the underlying reason?',
  'What was the base assumption?',
] as const;

export const debriefV2EnTranslations = {
  gather: {
    pageTitle: 'Review Discovered Facts',
    pageSubtitle:
      "We've structured the timeline. Refine these facts with your team before drafting insights.",
    stageLabels: {
      goalAndLeadDefinition: '1. Goal & Lead Definition',
      teamAssembly: '2. Team Assembly',
      planning: '3. Planning',
      execution: '4. Execution',
      monitoringAndControl: '5. Monitoring & Control',
      completionAndApproval: '6. Completion & Approval',
    },
    emptyStage: {
      title: 'No facts discovered automatically',
      subtitle: "We didn't find any facts for this stage.",
      addFactManually: '+ Add fact manually',
    },
    factRow: {
      viewSource: 'View source',
      edit: 'Edit',
      source: {
        jira: 'Jira',
        sharepoint: 'SharePoint',
        confluence: 'Confluence',
      },
    },
    addFact: '+ Add fact',
    continueButton: 'Continue',
    factDialog: {
      breadcrumbRoot: 'Fact',
      breadcrumbNew: 'New',
      breadcrumbEdit: 'Edit',
      titleLabel: 'Title',
      titlePlaceholder: 'Give the fact a short title',
      descriptionLabel: 'Description',
      descriptionPlaceholder:
        'Describe what happened - keep it factual and concise.',
      dateLabel: 'Date',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
    },
  },
  matchPoints: {
    pageTitle: 'Where was the outcome decided?',
    pageSubtitle:
      "Pick up to 3 process stages. We'll dig into the specifics of each one next.",
    pickButton: 'Pick',
    pickedLabel: 'Picked',
    selectionFooter: {
      hint: 'Select up to 3',
      counted: (count: number) => `${count} selected`,
      continue: 'Continue',
    },
  },
  deepDive: {
    factPickPrompt: (stageLabel: string) =>
      `Looking at ${stageLabel} - which fact stands out most to you?`,
    question: (index: number) => DEEP_DIVE_QUESTIONS[index] ?? '',
    lessonsPrompt: (stageLabel: string) =>
      `Got it - what's a lesson you'd take from ${stageLabel}?`,
    lessonsFollowUp: 'Got it. Anything else, or press Done?',
    inputPlaceholderAnswer: 'Type your answer…',
    inputPlaceholderLesson: 'Type a lesson - Send to add another, or Done…',
    send: 'Send',
    done: 'Done',
    pickFactHint: 'Pick a fact above to start.',
    matchPointPosition: (current: number, total: number) =>
      `Match-point ${current} of ${total}`,
  },
  lessons: {
    pageTitle: 'Lessons',
    leaderPill: 'Leader',
    factInFocusLabel: 'Which fact was discussed?',
    questions: DEEP_DIVE_QUESTIONS,
    lessonsHeading: 'Lessons',
    lessonsCaptured: (count: number) => `${count} captured`,
    lessonsEmpty: 'No lessons yet - add the first one.',
    addLesson: 'Add lesson',
    lessonPlaceholder: 'Type a lesson...',
    deleteLessonAria: 'Delete lesson',
    cancelLessonAria: 'Cancel lesson',
    waitingForParticipant: 'Waiting for participant...',
    outcomeAchieved: 'Result Achieved',
    outcomeNotAchieved: 'Result Not Achieved',
    participantsCount: (count: number) => `Participants (${count})`,
    finishDebrief: 'Finish debrief',
    manualFactLabel: 'Manual fact',
  },
} as const;
